import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    flexWrap: 'wrap',
    margin: '8px 0'
  },
  title: { fontWeight: 600, color: theme.palette.grey[800], marginBottom: 8 },
  elementName: {
    borderRadius: 16,
    border: `1px solid ${theme.palette.grey[400]}`,
    padding: '4px 16px',
    margin: '4px',
    cursor: 'pointer',
    display: 'inline-block'
  },
  selectedElement: {
    backgroundColor: theme.palette.primary.main,
    '& h5': {
      color: theme.palette.primary.contrastText
    }
  },
  text: { fontWeight: 500 }
}))
export default useStyles
